import * as actionTypes from './../actions/physicalActivityAction';

const initialState = {
  selectedDuration: 1,
  selectedDurationId: null,
  selectedIntensity: 1,
  selectedTemperature: 25,
  selectedType: null,
  data: false,
  pending: true,
  error: null,
  ready: false,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SELECT_DURATION:
      return {
        ...state,
        selectedDuration: action.selectedDuration,
        selectedDurationId: state.data.data[state.selectedType][action.selectedDuration].id,
      };
    case actionTypes.SELECT_INTENSITY:
      return {
        ...state,
        selectedIntensity: action.selectedIntensity,
      };
    case actionTypes.SELECT_TEMPERATURE:
      return {
        ...state,
        selectedTemperature: action.selectedTemperature,
      };
    case actionTypes.DEFAULT:
      return {
        ...state,
        selectedDuration: initialState.selectedDuration,
        selectedIntensity: initialState.selectedIntensity,
        selectedDurationId: state.data.data[action.selectedAnimalType][initialState.selectedDuration].id,
        selectedType: action.selectedAnimalType,
        ready: true,
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
